import { EffectCallback, useEffect } from 'react';

export default (callback: EffectCallback): void => {
  // eslint-disable-next-line react-hooks/exhaustive-deps -- This should execute one time, there is no need to rerun this
  useEffect(callback, []);
}